/**
 * Puces de filtres actifs, au-dessus de la grille de collection.
 *
 * Searchanise rend la page de collection en entier et n'affiche aucune
 * etiquette de filtre actif: ni snize-product-filters-header ni
 * reset-all ne sont rendus, mesure sur la page. Ce script les construit a
 * partir de ce que l'app expose bel et bien.
 *
 * Ce qui a ete mesure avant d'ecrire ceci, sur le live:
 *
 *  - l'etat filtre est dans l'URL, `?page=1&rb_stock_status=In%20Stock`, et
 *    dans le DOM, sous la forme d'un `li.snize-filter-checked` par valeur
 *    retenue;
 *  - retirer un filtre par programme fonctionne: il suffit de cliquer le meme
 *    noeud une seconde fois, l'URL repasse a `?page=1` et la case se decoche;
 *  - MAIS Searchanise reconstruit toute la colonne apres chaque changement.
 *    Garder une reference vers un noeud clique donne un noeud detache, et le
 *    clic suivant ne fait rien, en silence. Tout passe donc par une
 *    re-interrogation du DOM au moment du clic, jamais par une reference
 *    conservee.
 *
 * L'observateur est suspendu pendant qu'on ecrit dans le DOM: la rangee est
 * inseree dans #snize-search-results-grid-mode, que l'observateur surveille,
 * et sans cette pause chaque rendu declenchait le suivant.
 */
(function () {
  'use strict';

  var SEL = {
    results: '#snize_results',
    grid: '#snize-search-results-grid-mode',
    /* La barre de resultats: groupe de gauche, qui tient le compte. Noeud
       stable, verifie en le marquant puis en changeant un filtre. */
    bar: '.snize-horizontal-left',
    sidebar: '.snize-filters-sidebar',
    found: '.snize-main-panel-collection-results-found',
    /* Second compteur, le seul visible sous la rupture du desktop. */
    header: '.snize-search-results-header',
    input: '.snize-filters-sidebar input.snize-product-filters-checkbox:checked',
    block: '.snize-product-filters-block',
    row: 'chap-chips'
  };

  var observer = null;
  var timer = null;

  function strings() {
    var s = window.ChapmanFilterStrings || {};
    return {
      active: s.active || 'Filtres actifs',
      clear: s.clear || 'Tout effacer',
      remove: s.remove || 'Retirer ce filtre',
      productOne: s.productOne || 'produit',
      productOther: s.productOther || 'produits'
    };
  }

  /* On lit l'input, pas le texte.
     Premiere version: je prenais `li.querySelector('span.needsclick')`. Il y a
     DEUX spans de cette classe dans chaque li, et le premier est la case a
     cocher visuelle, vide. Le libelle revenait donc toujours vide et aucune
     puce n'etait construite.

     L'input porte tout, proprement:
       value="In Stock"
       data-se-facet-value-title="In Stock"
       data-se-facet-default-title="Disponibilité"
       name="stock_status"
     C'est plus solide que de gratter du texte, et ca evite au passage le
     compteur, qui vit dans un span enfant, et le badge de nombre de filtres
     actifs colle au titre de la facette. */
  function read() {
    var out = [];
    var inputs = document.querySelectorAll(SEL.input);
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var valeur = inp.getAttribute('data-se-facet-value-title') || inp.value || '';
      if (!valeur) continue;
      var block = inp.closest ? inp.closest(SEL.block) : null;
      out.push({
        facette: inp.getAttribute('data-se-facet-default-title') || '',
        valeur: valeur,
        nom: inp.name || '',
        bloc: block ? block.id : ''
      });
    }
    return out;
  }

  /* Retrait: on retrouve l'input VIVANT au moment du clic, puis on clique son
     label. Cliquer le label plutot que l'input laisse l'app faire son travail;
     c'est ce que fait un visiteur. */
  function remove(nom, valeur) {
    var inputs = document.querySelectorAll(SEL.input);
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      var v = inp.getAttribute('data-se-facet-value-title') || inp.value || '';
      if (inp.name !== nom || v !== valeur) continue;
      var lab = inp.closest ? inp.closest('label') : null;
      (lab || inp).click();
      return;
    }
  }

  /* Le "Tout effacer" de la rangee a ete retire le 2026-10-15: l'artboard ne
     le dessine pas ici, et Searchanise offre deja "Reinitialiser les filtres"
     dans la colonne. Deux controles pour la meme action, c'est un de trop. */

  function signature(data) {
    var parts = [];
    for (var i = 0; i < data.length; i++) parts.push(data[i].nom + '\u0001' + data[i].valeur);
    return parts.join('\u0002');
  }

  function build(data) {
    var s = strings();
    var row = document.createElement('div');
    row.className = SEL.row;
    row.setAttribute('data-sig', signature(data));

    for (var i = 0; i < data.length; i++) {
      var d = data[i];
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'chap-chips__chip';
      chip.setAttribute('data-nom', d.nom);
      chip.setAttribute('data-valeur', d.valeur);
      /* La facette ne s'affiche plus, l'artboard ne dessine que la valeur.
         Elle reste dans le libelle accessible: hors contexte, "En stock" et
         "Lelit" se liraient pareil. */
      chip.setAttribute('aria-label', s.remove + ' : '
        + (d.facette ? d.facette + ' ' + d.valeur : d.valeur));
      var v = document.createElement('span');
      v.className = 'chap-chips__value';
      v.textContent = d.valeur;
      chip.appendChild(v);

      var x = document.createElement('span');
      x.className = 'chap-chips__x';
      x.setAttribute('aria-hidden', 'true');
      x.textContent = '×';
      chip.appendChild(x);

      row.appendChild(chip);
    }

    return row;
  }

  /* Searchanise rend DEJA ses propres puces, mais pas au meme endroit selon la
     largeur: dans la colonne de filtres sur desktop, et au-dessus de la grille
     sous 768px. Cette rangee n'a donc de raison d'etre que sur desktop, ou elle
     remonte l'information a l'endroit que la maquette dessine; le CSS masque en
     contrepartie les puces natives de la colonne a cette largeur.

     Sous 768 on ne fait rien et on laisse celles de l'application, qui sont
     deja au bon endroit. Le test est explicite plutot que laisse au hasard d'un
     selecteur: la version precedente ne s'affichait pas sur mobile par accident,
     parce que les cases cochees n'y sont pas dans .snize-filters-sidebar. */
  function mobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  /* Le rail de gauche appartient a Searchanise (220px + 26px de marge, mesure
     a 1440 et a 1024). On le relit a chaque rendu au lieu de l'ecrire en dur,
     pour que la barre suive si l'application change cette largeur; la valeur
     de repli du CSS ne sert que le temps du premier rendu. */
  function setRail() {
    var root = document.querySelector(SEL.results);
    if (!root) return;
    var side = document.querySelector(SEL.sidebar);
    var px = 0;
    if (side) {
      var cs = window.getComputedStyle(side);
      if (cs.display !== 'none') {
        px = side.getBoundingClientRect().width + (parseFloat(cs.marginRight) || 0);
      }
    }
    /* Sur la RACINE et non sur la barre: la grille n'est pas une descendante
       de la barre et doit lire la meme valeur pour son plafond de largeur. */
    root.style.setProperty('--chap-snize-rail', Math.round(px) + 'px');
  }

  /* Searchanise ecrit "N resultats trouves pour \"<collection>\"", et le sert
     en francais meme sur /en. L'artboard demande "N produits". Le compte est
     isole dans un <b>, donc on le reprend tel quel et on ne reecrit que ce qui
     l'entoure; pas d'analyse de la phrase, qui changerait avec la langue.

     A 0 resultat l'element n'existe pas (Searchanise affiche son etat "aucun
     produit"), donc le cas zero ne se pose pas ici. */
  function renommeUn(el) {
    var b = el.querySelector('b');
    if (!b) return;
    var n = parseInt((b.textContent || '').replace(/[^0-9]/g, ''), 10);
    if (isNaN(n)) return;
    var s = strings();
    var mot = n === 1 ? s.productOne : s.productOther;
    if (el.getAttribute('data-chap-count') === String(n)) return;
    el.setAttribute('data-chap-count', String(n));
    el.textContent = '';
    var fort = document.createElement('b');
    fort.textContent = String(n);
    el.appendChild(fort);
    el.appendChild(document.createTextNode(' ' + mot));
  }

  /* Searchanise rend DEUX compteurs. Sur desktop seul .snize-main-panel-
     collection-results-found se voit; sous sa rupture a lui, c'est
     .snize-search-results-header, et le premier passe en visibility:hidden
     tout en gardant ses 28px, d'ou un trou en haut du panneau blanc.
     On renomme celui qui se voit et on replie celui que l'application masque. */
  function renommeCompte() {
    var cibles = [SEL.found, SEL.header];
    for (var i = 0; i < cibles.length; i++) {
      var el = document.querySelector(cibles[i]);
      if (!el) continue;
      if (window.getComputedStyle(el).visibility === 'hidden') {
        el.style.display = 'none';
        continue;
      }
      renommeUn(el);
    }
  }

  function paint() {
    /* AVANT le garde de la barre: le libelle du compte vaut a toutes les
       largeurs, alors que la barre n'existe que sur desktop. */
    renommeCompte();
    setRail();
    var bar = document.querySelector(SEL.bar);
    if (!bar) return;
    var existante = bar.querySelector('.' + SEL.row);
    /* Une rangee laissee par la version precedente, qui s'inserait dans la
       grille, serait orpheline: on la retire. */
    var grid = document.querySelector(SEL.grid);
    var vieille = grid && grid.querySelector('.' + SEL.row);
    if (vieille && vieille.parentNode) vieille.parentNode.removeChild(vieille);
    var data = mobile() ? [] : read();

    if (!data.length) {
      if (existante && existante.parentNode) existante.parentNode.removeChild(existante);
      return;
    }
    /* Idempotence: si rien n'a change, on ne touche pas au DOM. Sans ca, chaque
       rendu re-declenchait l'observateur. */
    if (existante && existante.getAttribute('data-sig') === signature(data)) return;

    var row = build(data);
    if (existante && existante.parentNode) {
      existante.parentNode.replaceChild(row, existante);
    } else {
      bar.appendChild(row);
    }
  }

  function render() {
    if (observer) observer.disconnect();
    try {
      paint();
    } finally {
      if (observer) setTimeout(observe, 0);
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(render, 120);
  }

  function observe() {
    var root = document.querySelector(SEL.results) || document.body;
    if (observer) observer.observe(root, { childList: true, subtree: true });
  }

  /* start() est rappele plusieurs fois, parce que Searchanise monte sa grille
     apres le chargement du document. Sans ce garde-fou on empilait un
     observateur par appel, et chaque mutation declenchait trois rendus. */
  function start() {
    if (!document.querySelector(SEL.results)) return;
    if (!observer) {
      observer = new MutationObserver(schedule);
      observe();
    }
    render();
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest('.chap-chips__chip') : null;
    if (chip) {
      e.preventDefault();
      remove(chip.getAttribute('data-nom'), chip.getAttribute('data-valeur'));
      return;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* Searchanise monte sa grille apres le chargement du document: on retente. */
  setTimeout(start, 1500);
  setTimeout(start, 4000);

  /* En franchissant 768px dans un sens ou dans l'autre, la rangee doit
     apparaitre ou disparaitre: sinon un redimensionnement laisse soit un
     doublon, soit rien. */
  if (window.matchMedia) {
    var mq = window.matchMedia('(max-width: 767px)');
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    else if (mq.addListener) mq.addListener(schedule);
  }
})();
